import { parse, stringify } from 'yaml';

/** Parse a YAML document into a plain JS value. Throws on malformed YAML. */
export function parseYaml(text: string): unknown {
  return parse(text);
}

/**
 * Serialize to YAML for config files. `lineWidth: 0` disables line wrapping (long URLs /
 * schema strings stay on one line, so diffs are clean), and key order is preserved (we build
 * objects in a deterministic field order in the writer), keeping git diffs minimal.
 */
export function stringifyYaml(value: unknown): string {
  return stringify(value, { indent: 2, lineWidth: 0 });
}
